import axios from "axios"
import SearchMixin from "@mixins/search"
import { ShareContexts } from "@mixins/app-contexts"

function mapGroupCounts(data = []) {
  if (!data.length) return null

  return data.reduce((acc, item) => {
    if (!item || item.group_id == null) return acc
    const key = `g${item.group_id}`
    acc[key] = (acc[key] || 0) + 1
    return acc
  }, {})
}

export const state = {
  activeCompany: null,
  propDataReloadKey: 0,
  fieldCardGridReloadKey: 0,
  companyContacts: [],
  liteGroupReportMetrics: null,
}

export const getters = {
  activeCompany: (state) => {
    return state.activeCompany
  },
  propDataReloadKey: (state) => {
    return state.propDataReloadKey
  },
  fieldCardGridReloadKey: (state) => {
    return state.fieldCardGridReloadKey
  },
  companyContacts: (state) => {
    return state.companyContacts
  },
  liteGroupReportMetrics: (state) => {
    return state.liteGroupReportMetrics
  },
}

export const actions = {
  setActiveCompany: ({ commit }, company) => {
    commit("SET_ACTIVE_COMPANY", company)
  },
  incrementPropDataReloadKey: ({ commit }) => {
    commit("INCREMENT_PROP_DATA_RELOAD_KEY")
  },
  incrementFieldCardGridReloadKey: ({ commit }) => {
    commit("INCREMENT_FIELD_CARD_GRID_RELOAD_KEY")
  },
  setCompanyContacts: ({ commit }, fields) => {
    commit("SET_COMPANY_CONTACTS", fields)
  },
  findCompanyContacts: ({ commit }, payload) => {
    commit("SET_COMPANY_CONTACTS", [])
    return new Promise((resolve, reject) => {
      axios
        .get(`snowflakes/company_contacts`, { params: payload })
        .then((resp) => {
          commit("SET_COMPANY_CONTACTS", resp.data)
          resolve(resp)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  loadLiteGroupReportMetrics: (
    { commit, dispatch, getters, rootGetters },
    companyId
  ) => {
    if (!companyId) return

    // Cases to gate:
    //  !this.isPublicLink &&
    //  !this.isDrawerView &&
    //  !this.fieldFilters &&
    //  !this.fieldSettings &&
    //  !this.activeGroup.srm_enabled

    const shareToken = rootGetters["auth/shareToken"]
    const activeGroup = rootGetters["auth/activeGroup"]
    if (!!shareToken || !activeGroup || activeGroup.srm_enabled) return

    const reqParams = {
      params: {
        // Snowflake params
        group_id: activeGroup.id,
        company_id: companyId,
        company_profile: true,
        lookup_context: ShareContexts.SHARED_FROM_ALL,
        keyword: null,
        // Search params
        q: SearchMixin.buildSearchObject({
          admin: false,
          indices: ["reports"],
          includes: ["name", "group_id", "model_type"],
          customAttrs: [],
          customFilters: [],
          sorts: [],
          filters: [
            {
              attr: "access_policy",
              type: "terms",
              value: [`g${activeGroup.id}:0`],
            },
          ],
          keywords: [],
          page: 1,
          per_page: 100,
        }),
      },
    }

    axios
      .get("snowflakes/company_report_relations", reqParams)
      .then((res) => {
        let results = _.get(res.data, "results", [])
        results = mapGroupCounts(results)
        commit("SET_LITE_GROUP_REPORT_METRICS", results)
      })
      .catch((error) => {
        commit("SET_LITE_GROUP_REPORT_METRICS", null)
        console.error(error)
      })
  },
}

export const mutations = {
  SET_ACTIVE_COMPANY(state, company) {
    state.activeCompany = company
  },
  INCREMENT_PROP_DATA_RELOAD_KEY(state) {
    state.propDataReloadKey++
  },
  INCREMENT_FIELD_CARD_GRID_RELOAD_KEY(state) {
    state.fieldCardGridReloadKey++
  },
  SET_COMPANY_CONTACTS(state, contactData) {
    state.companyContacts = contactData
  },
  SET_LITE_GROUP_REPORT_METRICS(state, metrics) {
    state.liteGroupReportMetrics = metrics
  },
}
